var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFFEAF",
    fillOpacity: 0.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7362 25.0313C44.5536 24.7124 44.2862 24.4502 43.9638 24.2738L32.96 18.2501C32.6659 18.0883 32.3357 18.0035 32 18.0035C31.6643 18.0035 31.3341 18.0883 31.04 18.2501L20.04 24.2726C19.7175 24.4489 19.4502 24.7111 19.2675 25.0301C19.0934 25.3319 19.0012 25.6741 19 26.0226V37.9776C19.0008 38.3356 19.0978 38.6869 19.2807 38.9948C19.4636 39.3026 19.7259 39.5557 20.04 39.7276L31.04 45.7488C31.3339 45.9112 31.6642 45.9964 32 45.9964C32.3358 45.9964 32.6661 45.9112 32.96 45.7488L43.96 39.7276C44.2741 39.5557 44.5364 39.3026 44.7193 38.9948C44.9023 38.6869 44.9992 38.3356 45 37.9776V26.0226C44.9998 25.6748 44.9088 25.3332 44.7362 25.0313ZM31 43.4513L27 41.2613V35.0001C26.9996 34.821 26.9511 34.6454 26.8597 34.4914C26.7682 34.3375 26.6371 34.211 26.48 34.1251L21 31.1251V27.1251L31 32.6001V43.4513ZM32 30.8601L22.0825 25.4301L26.3925 23.0713L31.5175 25.8776C31.6647 25.9581 31.8297 26.0003 31.9975 26.0003C32.1653 26.0003 32.3303 25.9581 32.4775 25.8776L37.6025 23.0713L41.9125 25.4301L32 30.8601ZM43 31.1226L37.52 34.1226C37.3629 34.2085 37.2318 34.335 37.1403 34.4889C37.0489 34.6429 37.0004 34.8185 37 34.9976V41.2588L33 43.4488V32.5926L43 27.1176V31.1226Z",
    fill: "#9C9B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerIcon);
export default __webpack_public_path__ + "static/media/empower-icon.2936169f744c9355c300ed7ecf5c9c9e.svg";
export { ForwardRef as ReactComponent };